import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { APP_CONFIG } from '@/app/core/config/app-config.token';

@Component({
  selector: 'app-announcement-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (!dismissed() && config.announcementBanner) {
      <div class="announcement-banner" role="alert">
        <svg
          class="banner-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <span class="banner-text">{{ config.announcementBanner }}</span>
        <button class="banner-dismiss" (click)="dismiss()" aria-label="Cerrar aviso">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    }
  `,
  styles: [
    `
      .announcement-banner {
        display: flex;
        align-items: center;
        gap: 0.625rem;
        padding: 0.625rem 1.5rem;
        background: var(--warning-subtle);
        border-bottom: 1px solid rgba(230, 92, 0, 0.25);
        color: var(--warning);
      }

      .banner-icon {
        width: 1.125rem;
        height: 1.125rem;
        flex-shrink: 0;
      }

      .banner-text {
        flex: 1;
        font-size: 0.875rem;
        font-weight: 500;
      }

      .banner-dismiss {
        background: none;
        border: none;
        cursor: pointer;
        color: var(--warning);
        padding: 0.25rem;
        border-radius: var(--radius-xs);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.7;
        transition: opacity 120ms;
        flex-shrink: 0;
      }
      .banner-dismiss:hover {
        opacity: 1;
      }
      .banner-dismiss svg {
        width: 1rem;
        height: 1rem;
      }
    `,
  ],
})
export class AnnouncementBannerComponent {
  protected readonly config = inject(APP_CONFIG);
  protected readonly dismissed = signal(false);

  protected dismiss(): void {
    this.dismissed.set(true);
  }
}
